import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, onUnmounted, watchEffect, reactive, shallowRef } from 'vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';
import { useI18n } from '../../../locales';
import TUIRoomEngine, {
  TUIRoomEvents,
  TUINetwork,
  TUINetworkQuality,
} from '@tencentcloud/tuiroom-engine-js';
import useRoomEngine from '../../../hooks/useRoomEngine';
import IconButton from '../../common/base/IconButton.vue';
import '../../../directives/vClickOutside';
import NetworkStabilityIcon from '../../common/icons/NetworkStabilityIcon.vue';
import NetworkFluctuationIcon from '../../common/icons/NetworkFluctuationIcon.vue';
import NetworkLagIcon from '../../common/icons/NetworkLagIcon.vue';
import NetworkDisconnectedIcon from '../../common/icons/NetworkDisconnectedIcon.vue';
import ArrowStrokeUpIcon from '../../common/icons/ArrowStrokeUpIcon.vue';
import { IconButtonLayout } from '../../../constants/room';

type TitleType = 'success' | 'warning' | 'danger' | 'info' | undefined;

interface StateType {
  title: string;
  titleType: TitleType | undefined;
  networkIcon: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkInfo',
  setup(__props) {

const roomEngine = useRoomEngine();
const { t } = useI18n();
const basicStore = useBasicStore();
const { networkInfo } = storeToRefs(basicStore);
const networkBoard = ref();
const showNetworkInfo: Ref<boolean> = ref(false);
const isShowNetworkContainer: Ref<boolean> = ref(false);

const state = reactive<StateType>({
  title: '',
  titleType: undefined,
  networkIcon: null,
});

const qualityMap: {
  [key in TUINetworkQuality]?: {
    title: string;
    titleType: TitleType;
    icon: any;
  };
} = {
  [TUINetworkQuality.kQualityExcellent]: {
    title: 'Stability',
    titleType: 'success',
    icon: shallowRef(NetworkStabilityIcon),
  },
  [TUINetworkQuality.kQualityPoor]: {
    title: 'Fluctuation',
    titleType: 'warning',
    icon: shallowRef(NetworkFluctuationIcon),
  },
  [TUINetworkQuality.kQualityVeryBad]: {
    title: 'Lag',
    titleType: 'danger',
    icon: shallowRef(NetworkLagIcon),
  },
  [TUINetworkQuality.kQualityDown]: {
    title: 'Disconnected',
    titleType: 'info',
    icon: shallowRef(NetworkDisconnectedIcon),
  },
};

watchEffect(() => {
  const quality = qualityMap[networkInfo.value.quality];
  if (quality) {
    isShowNetworkContainer.value = true;
    state.title = quality.title;
    state.titleType = quality.titleType;
    state.networkIcon = quality.icon;
  }
});

function handleClickNetworkIcon() {
  showNetworkInfo.value = !showNetworkInfo.value;
}

function handleClickOutSide() {
  if (showNetworkInfo.value) {
    showNetworkInfo.value = false;
  }
}

async function onUserNetworkQualityChanged({
  userNetworkList,
}: {
  userNetworkList: TUINetwork[];
}) {
  userNetworkList.forEach((userNetwork: TUINetwork) => {
    basicStore.setNetworkInfo(userNetwork);
  });
}

TUIRoomEngine.once('ready', () => {
  roomEngine.instance?.on(
    TUIRoomEvents.onUserNetworkQualityChanged,
    onUserNetworkQualityChanged
  );
});

onUnmounted(() => {
  roomEngine.instance?.off(
    TUIRoomEvents.onUserNetworkQualityChanged,
    onUserNetworkQualityChanged
  );
});

return { __sfc: true,roomEngine, t, basicStore, networkInfo, networkBoard, showNetworkInfo, isShowNetworkContainer, state, qualityMap, handleClickNetworkIcon, handleClickOutSide, onUserNetworkQualityChanged, IconButton, ArrowStrokeUpIcon, IconButtonLayout }
}

})